import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  decodeUrlLinks = (e) => {
    let EncodedUrl = e.currentTarget.dataset.encode;
    let DecodedUrl = atob(EncodedUrl);
    window.open(DecodedUrl, e.currentTarget.dataset.blank === 'true' ? '_blank' : '_self');
  }
}
